<template>
  <BCard v-if="enrollment">
    <BRow>
        <BCol cols="12" xl="6">
            <table class="mt-2 mt-xl-0 w-100">
                <ViewData vsIcon="BriefcaseIcon" vsLabel="Course" :vsValue="enrollment.course.name" />
                <ViewData vsIcon="UserIcon" vsLabel="Student" :vsValue="enrollment.student.full_name" />
                <ViewData vsIcon="CalendarIcon" vsLabel="Próxima renovación" :vsValue="enrollment.expiration_date ? formatDate(enrollment.expiration_date) : '-'" />

            </table>
        </BCol>
        <BCol cols="12" xl="6">
            <table class="mt-2 mt-xl-0 w-100">
                <ViewData vsIcon="UserIcon" vsLabel="Enrollment code" :vsValue="enrollment.code" />
                <ViewData vsIcon="ClockIcon" vsLabel="Start date" :vsValue="formatDate(enrollment.start_date)" />
                <ViewData vsIcon="ClockIcon" vsLabel="End date" :vsValue="enrollment.end_date ? formatDate(enrollment.end_date) : '-'" />
                <ViewData vsIcon="HomeIcon" vsLabel="Sucursal" :vsValue="enrollment.group_id ? enrollment.group.name : enrollment.course.group.name" />
            </table>
        </BCol>
        

        <BCol v-if="cursoMensual" cols="12" xl="6">
            <table class="mt-2 mt-xl-0 w-100">
                <ViewData vsIcon="DollarSignIcon" vsLabel="Pago mensualidad estándar" :vsValue="enrollment.monthly_payment ? formatCurrency(enrollment.monthly_payment) : '-'" />
                <ViewData vsIcon="DollarSignIcon" vsLabel="Pago primer mes" :vsValue="enrollment.first_month_payment ? formatCurrency(enrollment.first_month_payment) : '-'" />
                <ViewData vsIcon="DollarSignIcon" vsLabel="Pago último mes" :vsValue="enrollment.last_month_payment ? formatCurrency(enrollment.last_month_payment) : '-'" />
            </table>
        </BCol>
 
        <BCol v-if="!cursoMensual && enrollment.course" cols="12" xl="6">
            <table class="mt-2 mt-xl-0 w-100">
                <ViewData vsIcon="UserIcon" :vsLabel="'Plazo '+(index + 1)" :vsValue="term.term_payment" v-for="(term, index) in termsToPay" :key="index"  />
                
            </table>
        </BCol>

        <BCol cols="12" class="mt-2">
            <div class="d-flex flex-wrap">
                <BButton :to="{ name: 'enrollments-edit', params: { id: enrollment.id } }" variant="primary" v-if="ability.can('write', 'enrollment')"> {{$t('Edit')}} </BButton>
                <BButton variant="outline-danger" class="ml-1" @click="deletePopup(enrollment.id, 'enrollments/deleteEnrollment', 'enrollments')" v-if="ability.can('delete', 'enrollment')"> {{$t('Delete')}} </BButton>
            </div>
        </BCol>
    </BRow>
  </BCard>
</template>

<script>
import { BAlert, BRow, BCard, BCol, BButton, BLink } from 'bootstrap-vue'
import { onUnmounted, ref } from '@vue/composition-api'
import enrollmentsStoreModule from '../enrollmentsStoreModule'
import ViewData from '@/components/ViewData.vue'
import ability from '@/libs/acl/ability'
import popups from '@/hooks/popups'
import router from '@/router'
import store from '@/store'
import NumberInputValidated from '@/components/forms/NumberInputValidated.vue'
import DatepickerValidated from '@/components/forms/DatepickerValidated.vue'
import dateUtils from '@/hooks/dateUtils'
import currency from '@/utils/currency'



export default {
    components: { BAlert, BRow, BCol, BCard, BButton, BLink, ViewData, NumberInputValidated, DatepickerValidated},
    setup(){
        const {formatDate}=dateUtils()
        const { formatCurrency } = currency()
        const ENROLLMENT_MODULE_NAME = 'enrollments'
        const { deletePopup } = popups();
        const enrollment = ref(null)
        const termsToPay=ref([])
        const termsCourse=ref(null)
        const cursoMensual=ref(null)

        if (!store.hasModule(ENROLLMENT_MODULE_NAME)) store.registerModule(ENROLLMENT_MODULE_NAME, enrollmentsStoreModule)
        onUnmounted(() => { if(store.hasModule(ENROLLMENT_MODULE_NAME)) store.unregisterModule(ENROLLMENT_MODULE_NAME) })

        store.dispatch('enrollments/fetchEnrollment', { id: router.currentRoute.params.id }).then(response => {
            enrollment.value = response.data.enrollment
            termsCourse.value=response.data.terms

            for (let term of termsCourse.value) {

                if ((term.start_date<=enrollment.value.start_date) && (term.start_date <= enrollment.value.created_at.substring(0, enrollment.value.created_at.indexOf('T')))) {
                    termsToPay.value.push(term)
                }
            }

            if (termsToPay.value.length==0) {
                cursoMensual.value=true
            } else {
                cursoMensual.value=false
            }
        })

        return {
            enrollment,
            ability,
            deletePopup,
            termsToPay,
            cursoMensual, 
            formatDate,
            formatCurrency
        }
    }
}
</script>

<style lang="scss">
@import 'src/assets/scss/variables/_variables.scss';
table tr th {
  color: $primary;
}

table tr th span {
  text-transform: uppercase;
}
</style>
